import React, { Component } from "react";
import NavTab from '../../../components/common/global_layout/navTab'
import { Container } from "reactstrap";
import AdvancedSearchTransfert from '../../../components/common/Cars/advancedSearchTransfert'
import imgTransfert  from '../../../../src/transfert.png'
import CarCard from '../../../components/common/Cars/carCard'
import Footer from '../../../components/common/global_layout/footer'
import  { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";

class Transfert extends Component {
    render() { 
        return (
          <>
            <NavTab />
            <Container>
              <div className="linksContainer d-none d-md-flex justify-content-start">
                <NavLink className="pageLinks" to="/">
                  Ghurfaty
                </NavLink>
                <FontAwesomeIcon
                  className="align-self-center faChevron"
                  icon={faChevronRight}
                ></FontAwesomeIcon>
                <NavLink className="pageLinks" to="/cars">
                  Véhicule
                </NavLink>
                <FontAwesomeIcon
                  className="align-self-center faChevron"
                  icon={faChevronRight}
                ></FontAwesomeIcon>
                <NavLink className="pageLinks" to="/cars/transfert">
                  Transfert
                </NavLink>
              </div>
              <AdvancedSearchTransfert />
              <div id="transfertImg" className="px-1">
                <img className="img-fluid mt-1 mt-md-3" src={imgTransfert} alt="car name" />
              </div>
              <div className=" mb-3 px-1">
                <h2 id="nosRecom" className="text-center text-sm-start">Nos recommandations</h2>
                <div className="row typesCont d-flex justify-content-start mx-0 px-0">
                  <div className="col-6 col-md-3 mb-2 mt-2 px-0 mx-0 p-sm-2">
                    <CarCard
                      className="typeCard"
                      img="/imgs/carDetails/full.jpg"
                      name="4x4 Tucson 2021"
                      price="5000 DA"
                      carLink={"/cars/transfert/carDetails"}
                    />
                  </div>
                  <div className="col-6 col-md-3 mb-2 mt-2 px-1  p-sm-2">
                    <CarCard
                      className="typeCard "
                      img="/imgs/carDetails/full.jpg"
                      name="4x4 Tucson 2021"
                      price="5000 DA"
                      carLink={"/cars/transfert/carDetails"}
                    />
                  </div>
                  <div className="col-6 col-md-3 mb-2 mt-2 px-1  p-sm-2">
                    <CarCard
                      className="typeCard"
                      img="/imgs/carDetails/full.jpg"
                      name="4x4 Tucson 2021"
                      price="5000 DA"
                      carLink={"/cars/transfert/carDetails"}
                    />
                  </div>
                  <div className="col-6 col-md-3 mb-2 mt-2 px-1 p-sm-2">
                    <CarCard
                      className="typeCard"
                      img="/imgs/carDetails/full.jpg"
                      name="4x4 Tucson 2021"
                      price="5000 DA"
                      carLink={"/cars/transfert/carDetails"}
                    />
                  </div>
                  <div className="col-6 col-md-3 mb-2 mt-2 px-1 p-sm-2">
                    <CarCard
                      className="typeCard"
                      img="/imgs/carDetails/full.jpg"
                      name="4x4 Tucson 2021"
                      price="5000 DA"
                      carLink={"/cars/transfert/carDetails"}
                    />
                  </div>
                  <div className="col-6 col-md-3 mb-2 mt-2 px-1 p-sm-2">
                    <CarCard
                      className="typeCard"
                      img="/imgs/carDetails/full.jpg"
                      name="4x4 Tucson 2021"
                      price="5000 DA"
                      carLink={"/cars/transfert/carDetails"}
                    />
                  </div>
                </div>
              </div>
            </Container>
            <Footer />
          </>
        );
    }
}

  
  //connect function INJECTS dispatch function as a prop!!
export default Transfert;